/* tslint:disable */
/* eslint-disable */
export enum SubmissionMode {
  All = 'all',
  Individual = 'individual',
}
